const DROPSHIPPING_REQUEST_COMPANY = {
  STATUS: {
    APPROVED: 'Approved',
    DISAPPROVED: 'Disapproved',
    PENDING: 'Pending',
  },
};

export default DROPSHIPPING_REQUEST_COMPANY;
